import React, { useEffect, useState } from "react";
import { Modal, Form, Button } from "react-bootstrap";
import { allAPiServicesCall } from "../../services/apiServices";
import { getAuthConfig } from "../../services/apiUtils";
import { toast } from "react-toastify";

function SetRecArtistPriorityModel({ show, handleClose, artistDetails, handleFormSubmit, }) {
   console.log(artistDetails, "details")

  const [updatedData, setUpdatedData] = useState({
    priority: artistDetails.priority,
  });

  useEffect(() => {
    if (artistDetails) {
      setUpdatedData({ ...artistDetails });
    }
  }, [artistDetails]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setUpdatedData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };


  const onSubmit = async (e) => {
    e.preventDefault();

    const finalUpdatedData = { ...updatedData, };
 
    const updatedataplaylistData = {
      ...finalUpdatedData,
      artist_id: artistDetails.artist_id,
      pageType: artistDetails.pageType,
      genreSlug: artistDetails.genreSlug,
    }
    // console.log(updatedataplaylistData, "updatedataplaylistData");
    try {
      const updateResponse = await allAPiServicesCall.patchUpdateRecArtistPriority(
        updatedataplaylistData,
        getAuthConfig()
      );
      console.log(updateResponse,"updateresponse");

      if (updateResponse && updateResponse.success) {
        toast.success("Recommended Artist Priority updated successfully");
        handleFormSubmit?.();
        handleClose();
      } else {
        toast.error("Failed to update Recommended Artist Priority ");
      }
    } catch (error) {
      console.error("Failed to update Recommended Artist Priority :", error.response?.data || error);
      toast.error("An error occurred while updating the Recommended Artist Priority ");
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered fullscreen="sm-down">
      <Modal.Header closeButton>
        <Modal.Title>Edit Recommended Artist Priority</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={onSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>Set Priority</Form.Label>
            <Form.Control
              type="number"
              name="priority"
              value={updatedData.priority}
              onChange={handleInputChange}
              required
              style={{ minHeight: '44px' }}
            />
          </Form.Group>

          <div className="d-flex gap-2 mt-4">
            <Button
              variant="secondary"
              onClick={handleClose}
              className="flex-grow-1"
              style={{ minHeight: '44px' }}
            >
              Cancel
            </Button>
            <Button
              variant="primary"
              type="submit"
              className="flex-grow-1"
              style={{ minHeight: '44px' }}
            >
              Save Changes
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
}

export default SetRecArtistPriorityModel;
